import { useState } from 'react';

import SaveDialog from '../dialogs/SaveDialog';
import { Handler } from '../../common/handler';

import SaveIcon from '../../assets/icons/save.svg';

const SaveButton = ({ handler, title, uuid, onSuccess }: { handler: Handler | null; title: string; uuid: string | null; onSuccess?: (data: any) => void }) => {
    const [showSaveDialog, setShowSaveDialog] = useState<boolean>(false);

    return (
        <>
            <button
                className="right-button"
                onClick={() => {
                    setShowSaveDialog(true);
                }}
            >
                <img src={SaveIcon} alt="save-icon" />
            </button>
            <SaveDialog
                show={showSaveDialog}
                close={() => setShowSaveDialog(false)}
                handler={handler}
                title={title}
                onSuccess={onSuccess}
                id={uuid}
            ></SaveDialog>
        </>
    );
};

export default SaveButton;
